import axios from 'axios';

export function getSliders() {
  return axios.get(`${window.apiBase}/public/sliders`, {}).then(response => {
    return response.data;
  });
}
